import './GoalIntake.scss';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdOutlineSettings } from 'react-icons/md';
import { AlertDialog } from '@Components/AlertDialog';
import { Button } from '@Components/Button/Button';
import { Intent, Size } from '@Components/designConstants';
import { Page } from '@Components/Page/Page';
import { PAGE_NAMES } from '@Components/Page/page-constants';
import { useAppSelector } from '@src/redux';
import { currentCompanySelector } from '@src/redux/company';
import { GoalIntakeGoals } from './GoalIntakeGoals';
import { GoalIntakeSettingsModal } from './GoalIntakeSettingsModal';
import { useGoalRows } from './use-goal-intake';

export const GoalIntake = () => {
  const company = useAppSelector(currentCompanySelector);
  // Shares its cache with GoalIntakeGoals' own call -- only here to time the page load.
  const { isLoading } = useGoalRows(company);
  const [showSettings, setShowSettings] = useState(false);
  // Arriving from the retired Expected Bookings URL (navigation state from a tf alias, or
  // `?from=expected-bookings` from the bpm-frontend redirect): say so once, then drop both so a
  // refresh doesn't show it again.
  const location = useLocation();
  const navigate = useNavigate();
  const [showRetiredNotice, setShowRetiredNotice] = useState(
    Boolean(location.state?.retiredFrom) ||
      new URLSearchParams(location.search).get('from') === 'expected-bookings'
  );
  const hideRetiredNotice = () => {
    setShowRetiredNotice(false);
    const params = new URLSearchParams(location.search);
    params.delete('from');
    const search = params.toString();
    navigate(`${location.pathname}${search ? `?${search}` : ''}`, { replace: true, state: null });
  };

  return (
    <Page
      title={PAGE_NAMES.GOAL_INTAKE}
      pageType={PAGE_NAMES.GOAL_INTAKE}
      isLoading={isLoading}
      actions={
        <Button
          size={Size.LG}
          leadingElement={<MdOutlineSettings />}
          data-testid='goal-intake-settings-button'
          onClick={() => setShowSettings(true)}
        >
          Settings
        </Button>
      }
    >
      <GoalIntakeGoals company={company} />
      <AlertDialog
        show={showRetiredNotice}
        onHide={hideRetiredNotice}
        intent={Intent.INFO}
        title='Expected Bookings has been retired'
        dataTestId='goal-intake-retired-notice'
        body='Goal Intake is now the source of truth for these numbers. Enter your bookings here as budgets.'
      />
      {showSettings && (
        <GoalIntakeSettingsModal company={company} onHide={() => setShowSettings(false)} />
      )}
    </Page>
  );
};
